<template lang="pug">
  .container-childAccountList.container-padding
    c-header
      template(slot="left")
        h3 子账号管理
      template(slot="right")
        el-button(type="primary", @click="showCreate") 添加账号
      c-box
        .container-filters
          el-form(:model="filters",label-position="right",label-width="100px")
            el-row(:gutter="10")
              el-col(:span="8")
                el-form-item(label="子帐号/姓名")
                  el-input(v-model="filters.keyword")
              el-col(:span="8")
                el-form-item(label="角色")
                  el-select(v-model="filters.role_id")
                    el-option(:value="null", label="所有")
                    el-option(v-for="r in roleList", :key="r.id", :value="r.id", :label="r.title")
              el-col(:span="8")
                el-form-item(label="状态")
                  el-select(v-model="filters.status")
                    el-option(:value="null", label="所有")
                    el-option(:value="1", label="启用")
                    el-option(:value="2", label="禁用")
            el-form-item(label="")
              el-button(@click="setFilter",type="primary") 搜索
              el-button(@click="clearFilter", v-show="hasFilter") 清除
    c-box
      el-table(:data="list", fit, v-loading="listLoading")
        el-table-column(property="uname", label="帐号", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="role_name", label="角色", min-width="100", show-tooltip-when-overflow)
        el-table-column(property="nickname", label="姓名", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="mobile", label="手机号码", min-width="125", show-tooltip-when-overflow)
        el-table-column(property="email", label="邮箱", min-width="150", show-tooltip-when-overflow)
        el-table-column(property="last_active_ip", label="最后登录 IP", min-width="150", show-tooltip-when-overflow)
        el-table-column(property="last_active_time", label="最后登录时间", min-width="175", show-tooltip-when-overflow)
        el-table-column(label="状态", min-width="75", show-tooltip-when-overflow, v-slot="{ row }")
          el-switch(v-model="row.status", :active-value="1", :inactive-value="2", @change='changeStatus(row)')
        el-table-column(label="操作", width="175", v-slot="{ row }")
          .row-toolbox
            el-button(type="primary", size="small", @click="showEdit(row)") 编辑
            el-button(type="primary", size="small", @click="showResetPassword(row.id)") 重置密码
      .container-pagination
        el-pagination(layout="sizes, prev, pager, next, total",
          :current-page="page", :total="total", :page-size="size", :page-sizes="[5, 10, 15, 20, 25, 50]",
          @size-change="changeListSize", @current-change="getList")

    el-dialog(title="添加子账号", :visible.sync="create.show")
      el-form(:model="create.source", label-position="right", label-width="125px", :validate-on-rule-change="false")
        el-form-item(label="帐号名称", required)
          el-input(v-model="create.source.uname")
        el-form-item(label="姓名", required)
          el-input(v-model="create.source.nickname")
        el-form-item(label="密码", required)
          el-input(v-model="create.source.passwd", type="password")
        el-form-item(label="重复输入密码", required)
          el-input(v-model="create.source.passwd_2", type="password")
        el-form-item(label="角色", required)
          el-select(v-model="create.source.role_id")
            el-option(v-for="r in roleList", :key="r.id", :value="r.id", :label="r.title")
        el-form-item(label="手机号码")
          el-input(v-model="create.source.mobile")
        el-form-item(label="邮箱")
          el-input(v-model="create.source.email")
        el-form-item(label="状态", required)
          el-select(v-model="create.source.status")
            el-option(:value="1", label="启用")
            el-option(:value="2", label="禁用")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveCreate()") 保存
        el-button(@click="hideCreate()") 取消

    el-dialog(title="编辑子账号", :visible.sync="edit.show")
      el-form(:model="edit.source", label-position="right", label-width="125px", :validate-on-rule-change="false")
        el-form-item(label="帐号名称") {{ edit.source.uname }}
        el-form-item(label="姓名", required)
          el-input(v-model="edit.source.nickname")
        el-form-item(label="角色", required)
          el-select(v-model="edit.source.role_id")
            el-option(v-for="r in roleList", :key="r.id", :value="r.id", :label="r.title")
        el-form-item(label="手机号码")
          el-input(v-model="edit.source.mobile")
        el-form-item(label="邮箱")
          el-input(v-model="edit.source.email")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveEdit()") 保存
        el-button(@click="hideEdit()") 取消

    el-dialog(title="重置子账号密码", :visible.sync="resetPassword.show")
      el-form(:model="resetPassword.source", label-position="right", label-width="125px", :validate-on-rule-change="false")
        el-form-item(label="新密码", required)
          el-input(v-model="resetPassword.source.passwd", type="password")
        el-form-item(label="重复输入密码", required)
          el-input(v-model="resetPassword.source.passwd_2", type="password")
      .dialog-footer(slot="footer")
        el-button(type="primary", @click="saveResetPassword()") 保存
        el-button(@click="hideResetPassword()") 取消
</template>

<script>
export default {
  data () {
    return {
      page:   1,
      size:   10,
      status: 0,
      list:   [],
      total:  0,

      listLoading:  false,

      create: {
        show:   false,
        source: {
          uname:    null,
          nickname: null,
          passwd:   null,
          passwd_2: null,
          role_id:  null,
          status:   1,
          mobile:   null,
          email:    null,
          tel:      null,
        },
      },

      edit: {
        show:   false,
        source: {
          user_id:  null,
          nickname: null,
          role_id:  null,
          mobile:   null,
          email:    null,
          tel:      null,
        },
      },

      resetPassword: {
        show:   false,
        source: {
          user_id:  null,
          passwd:   null,
          passwd_2: null,
        },
      },

      filters: {
        role_id:  null,
        keyword:  null,
        status:   null,
      },
      hasFilter:    false,

      roleList:     [],
    };
  },
  methods: {
    showCreate () {
      this.create = {
        show:     true,
        source: {
          user_id:  null,
          uname:    null,
          nickname: null,
          passwd:   null,
          passwd_2: null,
          role_id:  null,
          status:   1,
          mobile:   null,
          email:    null,
          tel:      null,
        },
      };
      if (this.roleList.length > 0) {
        this.create.source.role_id = this.roleList[0].id;
      }
    },
    hideCreate () {
      this.create = {
        show:     false,
        source: {
          user_id:  null,
          uname:    null,
          nickname: null,
          passwd:   null,
          passwd_2: null,
          role_id:  null,
          status:   1,
          mobile:   null,
          email:    null,
          tel:      null,
        },
      };
    },
    saveCreate () {
      if (this.saveValidate()) {
        this.$store.dispatch('CREATE_CHILD_ACCOUNT', this.create.source).then(() => {
          this.hideCreate();
          this.getList(1);

          this.$message({
            type:     'success',
            message:  '子账号添加成功。'
          });
        }).catch(({ code, msg }) => {
          this.$message({
            type:     'error',
            message:  `子账号添加失败。${code}：${msg}`,
          });
        });
      }
    },
    saveValidate () {
      if (!this.create.source.uname) {
        this.$message({
          type:     'warning',
          message:  `请输入账号名称`,
        });
        return false;
      } else if (!this.create.source.nickname) {
        this.$message({
          type:     'warning',
          message:  `请输入姓名`,
        });
        return false;
      } else if (!this.create.source.passwd) {
        this.$message({
          type:     'warning',
          message:  `请设置密码`,
        });
        return false;
      } else if (this.create.source.passwd.length < 6 || this.create.source.passwd.length > 20) {
        this.$message({
          type:     'warning',
          message:  `密码长度应为 8 ~ 20 位`,
        });
        return false;
      } else if (!this.create.source.passwd_2) {
        this.$message({
          type:     'warning',
          message:  `请重复输入密码`,
        });
        return false;
      } else if (this.create.source.passwd !== this.create.source.passwd_2) {
        this.$message({
          type:     'warning',
          message:  `两次输入的密码不一致`,
        });
        return false;
      } else if (!this.create.source.role_id) {
        this.$message({
          type:     'warning',
          message:  `请设置角色`,
        });
        return false;
      }
      return true;
    },

    showEdit (row) {
      this.edit = {
        show:   true,
        source: Object.assign({}, row, {
          user_id:  row.id,
        }),
      };
    },
    hideEdit () {
      this.edit = {
        show:   false,
        source: {
          user_id:  null,
          nickname: null,
          role_id:  null,
          mobile:   null,
          email:    null,
          tel:      null,
        },
      };
    },
    saveEdit () {
      if (this.editValidate()) {
        this.$store.dispatch('EDIT_CHILD_ACCOUNT', this.edit.source).then(() => {
          this.hideEdit();
          this.refresh();

          this.$message({
            type:     'success',
            message:  '子账号修改成功。'
          });
        }).catch(({ code, msg }) => {
          this.$message({
            type:     'error',
            message:  `子账号修改失败。${code}：${msg}`,
          });
        });
      }
    },
    editValidate () {
      if (!this.edit.source.nickname) {
        this.$message({
          type:     'warning',
          message:  `请输入姓名`,
        });
        return false;
      } else if (!this.edit.source.role_id) {
        this.$message({
          type:     'warning',
          message:  `请设置角色`,
        });
        return false;
      }
      return true;
    },

    showResetPassword (user_id) {
      this.resetPassword = {
        show:   true,
        source: {
          user_id,
          passwd:   null,
          passwd_2: null,
        },
      };
    },
    hideResetPassword () {
      this.resetPassword = {
        show:   false,
        source: {
          user_id:  null,
          passwd:   null,
          passwd_2: null,
        },
      };
    },
    saveResetPassword () {
      if (this.resetPasswordValidate()) {
        const params = {
          user_id:    this.resetPassword.source.user_id,
          new_passwd: this.resetPassword.source.passwd,
        };
        this.$store.dispatch('RESET_CHILD_ACCOUNT_PASSWORD', params).then(() => {
          this.hideResetPassword();
          this.refresh();

          this.$message({
            type:     'success',
            message:  '子账号密码重置成功。'
          });
        }).catch(({ code, msg }) => {
          this.$message({
            type:     'error',
            message:  `子账号密码重置失败。${code}：${msg}`,
          });
        });
      }
    },
    resetPasswordValidate () {
      if (!this.resetPassword.source.passwd) {
        this.$message({
          type:     'warning',
          message:  `请设置新密码`,
        });
        return false;
      } else if (this.resetPassword.source.passwd.length < 8 || this.resetPassword.source.passwd.length > 20) {
        this.$message({
          type:     'warning',
          message:  `密码长度应为 8 ~ 20 位`,
        });
        return false;
      } else if (!this.resetPassword.source.passwd_2) {
        this.$message({
          type:     'warning',
          message:  `请重复输入密码`,
        });
        return false;
      } else if (this.resetPassword.source.passwd !== this.resetPassword.source.passwd_2) {
        this.$message({
          type:     'warning',
          message:  `两次输入的密码不一致`,
        });
        return false;
      }
      return true;
    },

    changeStatus ({ id, status }) {
      this.$store.dispatch('UPDATE_CHILD_ACCOUNT_STATUS', {
        user_id:  id,
        status,
      }).then(() => {
        this.$message({
          type:     'success',
          message:  '状态修改成功'
        });

        this.refresh();
      }).catch(({ code, msg }) => {
        this.$message({
          type:     'error',
          message:  `状态修改失败：${code}：${msg}`
        });
        this.refresh();
      });
    },

    getRoleList (page = 1) {
      const limit = 50;
      const offset = limit * (page - 1);

      this.$store.dispatch('GET_ROLE_LIST', {
        offset,
        limit,
        stat:     true,
      }).then((data) => {
        this.roleList = this.roleList.concat(data.list);

        if ((data.total - offset) >= limit) {
          this.getRoleList(page + 1);
        }
      }).catch(({ msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      });
    },

    setFilter () {
      if (this.filters.role_id || this.filters.keyword || this.filters.status) {
        this.hasFilter = true;
      } else {
        this.hasFilter = false;
      }

      this.refresh();
    },
    clearFilter () {
      this.filters = {
        role_id:  null,
        keyword:  null,
        status:   null,
      };
      this.hasFilter = false;
      this.refresh();
    },
    refresh () {
      this.getList(this.page);
    },
    changeListSize (size = 20) {
      this.size = size;
      this.getList(1);
    },
    getList (page = 1) {
      if (!this.listLoading) {
        this.page = page;
        this.listLoading = true;
      } else {
        return;
      }

      const _filters = Object.assign({}, this.filters);
      this.$store.dispatch('GET_CHILD_ACCOUNT_LIST', Object.assign({
        offset:   this.size * (this.page - 1),
        limit:    this.size,
        stat:     true,
      }, _filters)).then((data) => {
        this.list = data.list;
        this.total = data.total;
      }).catch(({ msg }) => {
        this.$alert(`${msg}`, {
          type:     'error'
        });
      }).finally(() => {
        this.listLoading = false;
      });
    },

  },
  mounted () {
    this.getList(1);
    this.getRoleList();
  },
};
</script>